module.exports = __webpack_public_path__ + "static/media/fabric-logo.e560a225.svg";